import {
  EmptyContent,
  EmptyNotesLogo,
  EmptyContentTextWrapper,
  EmptyContentTitle,
  EmptyContentSubtitle,
  EmptyContentWrapper,
} from './EmptyNotesBody.styled';

export const EmptyNotesBody = () => {
  return (
    <EmptyContentWrapper>
      <EmptyContent>
        <EmptyNotesLogo />
        <EmptyContentTextWrapper>
          <EmptyContentTitle>There are no notes to show</EmptyContentTitle>
          <EmptyContentSubtitle>
            Once a note is submitted, you’ll find it here.
          </EmptyContentSubtitle>
        </EmptyContentTextWrapper>
      </EmptyContent>
    </EmptyContentWrapper>
  );
};
